import { Action, State, StateContext } from "@ngxs/store";
import { SampleService } from "../../services/sample.service";
import { LoadSampleInfoIntoState, SetRelevantSample, StoreSampleCount } from "./sample.actions";
import { LocalStorageService } from "../../services/local-storage.service";
import { Inject, Injectable } from "@angular/core";

// State model
export interface SampleStateModel {
    hash: string;
    type: string;
    count: number;

    knownSampleCounts: {hash: string, count: number}[];
}

// Request states
// State
@State<SampleStateModel>({
    name: 'sample',
    defaults: {
        hash: null,
        type: null,
        count: null,

        knownSampleCounts: [],
    }
})
@Injectable()
export class SampleState {
    constructor(
        private sampleService: SampleService,
        private localStorage: LocalStorageService,
    ) {}

    getHash(ctx: StateContext<SampleStateModel>): string {
        var hash;
        hash = ctx.getState().hash;
        if (!hash) {
            hash = this.localStorage.getItem('relevant_sample_hash');
            hash = (hash === 'null') ? null : hash;
        }

        if (hash) {ctx.patchState({hash: hash});}
        return hash;
    }

    getType(ctx: StateContext<SampleStateModel>): string {
        var type;
        type = ctx.getState().type;
        if (!type) {
            type = this.localStorage.getItem('relevant_sample_type');
            type = (type === 'null') ? null : type;
        }

        if (type) {ctx.patchState({type: type});}
        return type;
    }

    getCount(ctx: StateContext<SampleStateModel>): string {
        var count;
        // Get count from state
        count = ctx.getState().count;

        // If not in state, get from local storage
        if (count === null) {
            count = this.localStorage.getItem('relevant_sample_count');
            count = (count === 'null') ? null : parseInt(count);
            ctx.patchState({count});
        }

        // If not in local storage, get from service
        if (count === null) {
            var hash = this.getHash(ctx);
            var type = this.getType(ctx);
            
            if (hash && type) {
                this.sampleService.startGettingCountByHashAndType(hash, type);
            } 
        }
        return count;
    }

    @Action(SetRelevantSample)
    setRelevantSample(  ctx: StateContext<SampleStateModel>,
                        { payload }: SetRelevantSample) {
        // Update state & storage
        ctx.patchState({
            hash: payload.hash,
            type: payload.type,
            count: payload.count
        });

        this.localStorage.setItem('relevant_sample_hash', payload.hash);
        this.localStorage.setItem('relevant_sample_type', payload.type);        
        if (payload.count !== null) {
            this.localStorage.setItem('relevant_sample_count', payload.count.toString());
            return;
        } else if (payload.count === null){
            this.localStorage.setItem('relevant_sample_count', null);
        }

        
        // Fetch count if null
        if (payload.hash) {this.sampleService.startGettingCountByHashAndType(payload.hash, payload.type);}
        return;
    }

    @Action(LoadSampleInfoIntoState)
    loadSampleInfoIntoState(ctx: StateContext<SampleStateModel>) {
        // Get count
        this.getHash(ctx);
        this.getType(ctx);
        this.getCount(ctx);
    }

    @Action(StoreSampleCount)
    storeSampleCount(ctx: StateContext<SampleStateModel>, { payload }: StoreSampleCount) {
        ctx.patchState({
            knownSampleCounts: [...ctx.getState().knownSampleCounts, {hash: payload.hash, count: payload.count}]
        });
    }
}